import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export function Chapter({ children }) {
  return (
    <Reveal>
      <div className="mono text-xs sm:text-sm tracking-[0.25em] uppercase text-secondary font-medium mb-5">
        {children}
      </div>
    </Reveal>
  );
}

export function SectionTitle({ children, dark = false, className = "" }) {
  return (
    <Reveal delay={0.05}>
      <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-balance max-w-3xl ${dark ? "text-white" : "text-slate-900"} ${className}`}>
        {children}
      </h2>
    </Reveal>
  );
}
